/* bf26y-r10.js (13 Oct 2026): display-only clean-ups. Never changes input values or product data. Rollback: delete the script line at the end of snippets/bf26a-a11y.liquid. */
(function () {
  'use strict';
  function rkLazy(fn, own) { var go = function () { if (window.BF26 && BF26.lazy) BF26.lazy(fn); else own(); }; if ((window.BF26 && BF26.lazy) || document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go); } /* 21 Oct 2026: shared sweep in bf26-core.js */
  var SO = /\s*[-–]\s*Sold Out\b/gi;
  var UN = /\s*[-–]\s*(?:Sold Out\s*[-–]\s*)?(?:Sold Out|Unavailable)\b/gi;
  var QUICK = /[-–]\s*Sold Out|favorite|you tracking|\s[-–]\s[a-z]|money[- ]back/i;
  var EXCL = 'script,style,option,textarea,input,title,blockquote,[class*="jdgm"],[class*="review"],[class*="testimonial"],[class*="quote"],.bf27-qcard,#menu-drawer,header';
  var KEEP = '.bf26z-trust,[class*="bf26z-trust"],cart-drawer,#CartDrawer,[id$="__studio_offer"],footer';
  var CART = 'cart-drawer,#CartDrawer,.cart-drawer,form[action="/cart"],[id*="cart-footer"],[class*="cart__"]';
  var PRICE = '[class*="price"],[class*="Price"],.quantity-break,.bf26a-satc,[class*="bb-card"],[class*="bf26s"],s';
  var busy = false, decCount = new WeakMap();

  function opts() {
    document.querySelectorAll('option').forEach(function (o) {
      var t = o.textContent;
      if (!/Sold Out|Unavailable/i.test(t)) return;
      if (/\(sold out\)\s*$/.test(t)) { if (!o.disabled) o.disabled = true; if (o.hidden) o.hidden = false; return; }
      var nt = t.replace(UN, '').replace(SO, '').trim() + ' (sold out)';
      if (nt !== t) o.textContent = nt;
      if (!o.disabled) o.disabled = true;
      if (o.hidden) o.hidden = false;
    });
  }

  function text() {
    var w = document.createTreeWalker(document.body, 4, null), n, list = [], pr = [];
    while ((n = w.nextNode())) {
      var v0 = n.nodeValue;
      if (v0.length > 3 && QUICK.test(v0)) list.push(n);
      if (/\.00(?!\d)/.test(v0)) pr.push(n);
    }
    list.forEach(function (n) {
      var p = n.parentElement; if (!p) return;
      var v = n.nodeValue, o = v, ex = p.closest(EXCL), keep = p.closest(KEEP);
      /* r53 W4: icon ligatures (Material Symbols spans) are icon names, not copy: "favorite" must stay "favorite" or the icon breaks */
      if (p.closest('script,style,textarea,option,.material-symbols-outlined,[class*="material-symbols"],[class*="material-icon"]')) return;
      v = v.replace(SO, '');
      v = v.replace(/\bfavorite\b/g, 'favourite').replace(/\bFavorite\b/g, 'Favourite').replace(/Please enter you tracking/g, 'Please enter your tracking');
      if (!ex) v = v.replace(/(\S)\s[-–]\s(?=[a-z])/g, '$1, ');
      if (!keep && !ex) {
        /* r55 FX2 (15 Oct 2026, Alexander): "30-day money-back guarantee" is the approved wording everywhere. It is no longer rewritten to
           the old returns wording, and "Can I try them risk free?" is no longer reworded. Only a repeated stand-alone guarantee card is still hidden. */
        if (/^\s*30-day money[- ]back guarantee\s*$/i.test(v)) {
          var box = p.closest('li.splide__slide, .multicolumn-card, .icon-bar-card, [class*="icons__item"], [class*="icon-item"]') || null;
          if (box && !box.hasAttribute('data-r10-hide')) { box.setAttribute('data-r10-hide', '1'); box.style.display = 'none'; }
        }
      }
      if (v !== o) n.nodeValue = v;
    });
    /* whole-dollar prices show without .00 on cards and product pages (cart keeps cents); a node is touched at most 4 times so no script can ping-pong with it */
    pr.forEach(function (n) {
      var p = n.parentElement; if (!p || !p.closest(PRICE) || p.closest(CART) || p.closest('script,style,textarea,option,input')) return;
      var c = decCount.get(n) || 0; if (c > 4) return;
      var v = n.nodeValue.replace(/([$£€¥]\s?\d[\d,]*)\.00(?!\d)/g, '$1');
      if (v !== n.nodeValue) { decCount.set(n, c + 1); n.nodeValue = v; }
    });
  }

  function attrs() {
    document.querySelectorAll('[aria-label*="Sold Out" i],[title*="Sold Out" i],[alt*="Sold Out" i]').forEach(function (e) {
      ['aria-label', 'title', 'alt'].forEach(function (a) {
        var v = e.getAttribute(a);
        if (v && /[-–]\s*Sold Out/i.test(v)) e.setAttribute(a, v.replace(SO, ''));
      });
    });
  }

  /* RKKN in headings and table heads gets the brand K (same markup as the page title) */
  function rk() {
    document.querySelectorAll('main h1,main h2,main h3,main h4,main th,main .accordion__title,main summary,main .collapsible-content__heading').forEach(function (h) {
      if (h.closest('#menu-drawer,header') || h.querySelector('.bf26-rk')) return;
      var w = document.createTreeWalker(h, 4, null), n, hit = [];
      while ((n = w.nextNode())) if (/RKKN/.test(n.nodeValue)) hit.push(n);
      hit.forEach(function (n) {
        var parts = n.nodeValue.split('RKKN'), f = document.createDocumentFragment();
        parts.forEach(function (s, i) {
          if (s) f.appendChild(document.createTextNode(s));
          if (i < parts.length - 1) {
            var sp = document.createElement('span'); sp.className = 'bf26-rk';
            sp.innerHTML = 'R<span class="bf26-rk-k">K</span>KN';
            f.appendChild(sp);
          }
        });
        n.parentNode.replaceChild(f, n);
      });
    });
  }

  /* bottle and bands pages: Colour first, then Quantity (same order as the cap and clip pages) */
  function order() {
    var q = document.querySelector('.main-product__info-container > .product-form__quantity'), v = document.querySelector('.main-product__info-container > variant-selects');
    if (q && v && (q.compareDocumentPosition(v) & 4)) v.parentNode.insertBefore(q, v.nextSibling);
  }

  /* socks collection: the hero button "Shop the styles" links to #sock-grid, so give the product grid that anchor */
  function sockGrid() {
    if (document.getElementById('sock-grid') || !document.querySelector('a[href="#sock-grid"]')) return;
    var g = document.querySelector('[id^="shopify-section-"][id$="main-collection-product-grid"]');
    if (!g) return;
    var a = document.createElement('div'); a.id = 'sock-grid'; a.style.cssText = 'height:0;scroll-margin-top:80px';
    g.parentNode.insertBefore(a, g);
  }

  /* RKKN Set page: hide the fixed buy bar while the footer is on screen (it covered the footer links) */
  var stDone = false;
  function sticky() {
    if (stDone) return;
    var st = document.querySelector('.s-sticky'), ft = document.querySelector('footer') || document.querySelector('.shopify-section-group-footer-group');
    if (!st || !ft || !window.IntersectionObserver) return;
    stDone = true;
    new IntersectionObserver(function (es) { st.classList.toggle('bf26y-r10-off', es[0].isIntersecting); }, { threshold: 0 }).observe(ft);
  }

  function run() {
    if (busy) return;
    busy = true;
    try { opts(); text(); attrs(); rk(); sockGrid(); sticky(); } catch (e) {} /* 21 Oct 2026: order() off, the templates already put the picker first */
    busy = false;
  }
  var t = 0;
  function sched() { clearTimeout(t); t = setTimeout(run, 120); }
  function start() {
    run();
    if (window.MutationObserver) {
      rkLazy(run, function () { new MutationObserver(sched).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'disabled'] }); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', run);
})();
